module.exports = __webpack_public_path__ + "img/eg-3.be93a365.jpg";